













import Vue from 'vue';

import Alert from "./components/Alert.vue";
import LoadingState from './components/LoadingState.vue';

export default Vue.extend({
	name: 'app',

	metaInfo():any {

		const title = `Digitala Midnattsloppet - Loppgeneratorn`;
		const desc = "Skapa ditt eget digitala Midnattslopp!";

		return {
			title: title,
			meta: [
				{
					vmid: "description",
					name: "description",
					content: desc,
				},
				{
					vmid: "og:title",
					property: "og:title",
					content: title,
				}	,
				{
					vmid: "og:description",
					property: "og:description",
					content: desc,
				},
			]
		}
	},

	components: {
		Alert,
		LoadingState,
	},

	mounted() {
		setTimeout(() => {
			//@ts-ignore
			window.prerenderReady = true;
		}, 2000);
	},


	computed: {
	},

});
